import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { payhistoryDetail } from './payhistoryDetails';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class PayhistoryService {
    private _payhistoryServiceReportUrl = CONFIGURATION.baseServiceUrl + 'payhistoryreport/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

    constructor(private _http: Http) { }

    getReportData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._payhistoryServiceReportUrl + 'reference-data', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getPayHistoryServiceReports(filterCriteria: any): Observable<payhistoryDetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        const fileName = 'payhistory-data?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup;
        return this._http.get(this._payhistoryServiceReportUrl + fileName, { headers: headers })
            .map((response: Response) => <payhistoryDetail[]>response.json())
            .catch(this.handleError);
    }
    getSSnData(ssnData: any): Observable<payhistoryDetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
            + '&TaxYear=' + ssnData.taxyear
            + '&ControlGroup=' + ssnData.controlgroup
            + '&ReportName=' + 'PayHistoryReport';
        return this._http.get(this._ssnUrl + fileName, { headers: headers })
            .map((response: Response) => <payhistoryDetail[]>response.json().payHistoryReportData)
            .catch(this.handleError);
    }
    downloadExcelReport(filterCriteria: any): any {
        const fileName = 'excel-download?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup;
        const url = this._payhistoryServiceReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })

    }
    //   downloadPDFReport(filterCriteria: any): any {
    //       let fileName = 'processBreakInReportPDFUpload?WorkYear=' + filterCriteria.selectedYear
    //           + '&ControlGroup=' + filterCriteria.selectedControlGroup;
    //       const url = this._payhistoryServiceReportUrl + fileName
    //       const headers = new Headers();
    //       headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    //       headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    //       // headers.append('Authorization', 'JWT ' + localStorage.getItem('id_token'));
    //       return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
    //           (res) => {
    //               const a = document.createElement('a');
    //               document.body.appendChild(a);
    //               const blob = new Blob([res.blob()], { type: 'application/zip' });
    //               const downloadUrl = URL.createObjectURL(blob);
    //               window.open(downloadUrl);
    //           })
    //   }

    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getPayHistoryReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._payhistoryServiceReportUrl + `v2/payhistory-data`,data, { headers: headers })
          .map((res: Response) => res.json())
          .catch(this.handleError);
    }

    getYearlyPayHistoryReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._payhistoryServiceReportUrl + `yearlpay-data`,data, { headers: headers })
          .map((res: Response) => res.json())
          .catch(this.handleError);
    }

    downloadYearlyExcelReport(data: any): any {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._payhistoryServiceReportUrl + `yearlypay-exceldownload`, data, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }


}




// WEBPACK FOOTER //
// ./src/app/payhistory/payhistory.service.ts